//Reducer for loading filter data options

const filtersDataReducerDefaultState = {
    isLoaded : false
};

export default (state = filtersDataReducerDefaultState, action) => {
    switch(action.type) {
        case 'SET_IS_LOADED':
            return {
                ...state,
                isLoaded : action.isLoaded
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/Reducers/filtersData.js